export default __webpack_public_path__ + "static/media/certificate.5cdd67e1.png";